import { render, staticRenderFns } from "./BillReceivableCommonPrint.vue?vue&type=template&id=6b2797f2&scoped=true"
import script from "./BillReceivableCommonPrint.vue?vue&type=script&lang=js"
export * from "./BillReceivableCommonPrint.vue?vue&type=script&lang=js"
import style0 from "./BillReceivableCommonPrint.vue?vue&type=style&index=0&id=6b2797f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2797f2",
  null
  
)

export default component.exports